// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from "../../../store/store";

import { fetchEquipmentDetails } from "../../../store/equipment/equipmentActions";

export async function equipmentLoader({ params }) {
  const { equipmentId } = params;

  if (!equipmentId) {
    return null;
  }
  // get equipment by id
  const state = store.getState();
  const companyUuid = state.companies?.company?.company_uuid;

  if (!companyUuid) {
    return null;
  }

  await store.dispatch(
    fetchEquipmentDetails({ companyUuid, equipUUID: equipmentId }),
  );

  return null;
}

equipmentLoader.hydrate = true;
